import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import { useApiTrigger } from '../../hooks/useApiTrigger';
import React, { forwardRef } from 'react';
import * as Icons from "@mui/icons-material";

const StatCard = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto: infoCard } = useApiTrigger(data, filters);
    const dto = infoCard[0];

    const renderIcon = () => {
        const TargetIcon = Icons[data.icon] || Icons["Help"];
        return (
            <Avatar
                sx={{
                    bgcolor: data?.transparencyColor ? `${data.color}${data.transparencyColor}` : data.color,
                    color: data?.transparencyColor ? data.color : 'white',
                    width: 56,
                    height: 56
                }}
            >
                <TargetIcon
                    sx={{ fontSize: 35 }}
                />
            </Avatar>
        )
    }

    return (
        <Card style={{ width: "100%", height: "100%" }}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {renderIcon()}

                    <Box>
                        <Typography fontWeight={500} noWrap>
                            {data.accion}
                        </Typography>
                        <Typography variant="h5" fontWeight="bold">
                            {dto?.value || 0}
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                            <Typography variant="caption" sx={{ color: data.color, fontWeight: 'bold', mr: 0.5 }}>
                                {dto?.trend}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {dto?.label || ''}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
});

export default StatCard